import { formatAmount } from 'shared/helpers/utils';

type UsePrepaidWalletBalanceReturn = {
  balanceCents: number;
  formattedBalance: string;
};

// Defaults to a zero balance until live wallet data is wired into state.
export function usePrepaidWalletBalance(): UsePrepaidWalletBalanceReturn {
  const balanceCents = 0;
  return { balanceCents, formattedBalance: formatAmount(balanceCents) };
}
